"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useWeb = void 0;
// ---------- import Packs
var react_1 = __importDefault(require("react"));
// ---------- export Helper
var useWeb = function (ref) {
    // ---------- set Conditionals
    // const condWeb = Platform.OS === 'web';
    var condWeb = false;
    // ---------- set Hooks
    var isHovered = condWeb && useHover(ref);
    // const isFocused = useFocus(ref);
    // const isActive = useActive(ref);
    // ---------- set Return
    return { isHovered: isHovered };
};
exports.useWeb = useWeb;
// ----------- set Default Function
var useHover = function (ref) {
    // ----------- set Callbacks
    var callFunc1 = function () { return setStatus(true); };
    // const callFunc2 = () => setStatus(false);
    // ----------- set Hooks
    var _a = react_1["default"].useState(false), sttStatus = _a[0], setStatus = _a[1];
    useListener(ref, 'mouseenter', callFunc1);
    // useListener(ref, 'mouseleave', callFunc2);
    // ----------- set Return
    return sttStatus;
};
var useListener = function (el, evtName, callBack) {
    // ----------- set Effects
    var fxIn = function () { return el.current.addEventListener(evtName, callBack); };
    // const fxOut = () => () => el.current.removeEventListener(evtName, callBack);
    // ----------- set Hooks
    react_1["default"].useEffect(fxIn, []);
    // React.useEffect(fxOut, []);
};
